import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import axios from 'axios'

// Импорт переводов
import en from './translations/en/en'
import ru from './translations/ru/ru'
import ua from './translations/ua/ua'
import cs from './translations/cs/cs'

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  ua: { translation: ua },
  cs: { translation: cs },
}

// Поддерживаемые языки
const supportedLanguages = ['en', 'ru', 'ua', 'cs']

// Маппинг страны в язык
const countryToLang = {
  RU: 'ru',
  UA: 'ua',
  CZ: 'cs',
  SK: 'cs',
  US: 'en',
  GB: 'en',
  DE: 'en',
}

// Определяем язык по IP
const detectLanguageByIP = async () => {
  try {
    const res = await axios.get('https://ipapi.co/json/')
    const country = res.data.country
    const lang = countryToLang[country] || 'en'
    return supportedLanguages.includes(lang) ? lang : 'en'
  } catch (err) {
    console.warn('Geo IP detection failed. Defaulting to English.', err)
    return 'en'
  }
}

// Возвращаем промис инициализации
const initI18n = async () => {
  const detectedLang = await detectLanguageByIP()

  await i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: detectedLang,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
    })

  return i18n
}

// export default initI18n
export { initI18n }
export default i18n